import { Toolbar } from "@mui/x-data-grid-pro";
import type { FC } from "react";
import { ExportMenu } from "../../../../modules/generic/components/export-menu";

export const ExportToolbar: FC = () => {
  return (
    <Toolbar>
      <ExportMenu hideText={true} />
    </Toolbar>
  );
};
